import React from "react";
import Seo from "@/components/Seo";

const sections = [
  {
    title: "1. Acceptance of Terms",
    body: "By accessing or using ravemora.global and any Ravemora Global Private Limited service, you agree to these Terms & Conditions. If you do not agree, please do not use the site or services."
  },
  {
    title: "2. Services",
    body: "Ravemora provides career coaching, executive placement and payroll administration. Specific engagements are governed by separate written agreements with candidates or client organizations, which prevail over these terms in case of conflict."
  },
  {
    title: "3. Candidate Conduct",
    body: "Candidates warrant that all information (resume, employment history, credentials, references) is accurate and complete. Misrepresentation may lead to withdrawal of placement offers and removal from our talent network."
  },
  {
    title: "4. Client Obligations",
    body: "Client organizations agree to timely payment of invoices, to comply with all statutory obligations toward manpower deployed under Ravemora's payroll, and to provide safe working conditions in line with Indian labour law."
  },
  {
    title: "5. Fees & Payment",
    body: "Placement fees are billed on successful joining, subject to a 90-day replacement warranty. Payroll fees are billed monthly. All fees are exclusive of GST which will be charged at prevailing rates."
  },
  {
    title: "6. Intellectual Property",
    body: "All content on ravemora.global, including logos, coaching curricula, AI screening outputs and reports, is the property of Ravemora Global Private Limited. Reproduction without written consent is prohibited."
  },
  {
    title: "7. Limitation of Liability",
    body: "To the maximum extent permitted by law, Ravemora's total liability for any claim shall not exceed the fees paid to Ravemora in the preceding six months in respect of the specific service giving rise to the claim."
  },
  {
    title: "8. Governing Law",
    body: "These terms are governed by the laws of India. Any dispute shall be subject to the exclusive jurisdiction of the courts at Bengaluru, Karnataka."
  },
  {
    title: "9. Changes",
    body: "We may update these terms from time to time. Material changes will be notified via email or a prominent notice on the website. Continued use after changes constitutes acceptance."
  },
];

export default function Terms() {
  return (
    <div className="max-w-[900px] mx-auto px-6 lg:px-10 py-24" data-testid="terms-page">
      <Seo path="/terms" title="Terms & Conditions" description="Terms and conditions governing use of ravemora.com and Ravemora Global services." />
      <div className="label-eyebrow text-navy/60">Legal</div>
      <h1 className="serif-display text-4xl md:text-5xl lg:text-6xl mt-4 leading-tight">Terms &amp; Conditions</h1>
      <p className="text-navy/50 mt-4">Effective date: 1 January 2026</p>
      <div className="hairline my-10" />
      <div className="space-y-10">
        {sections.map((s) => (
          <section key={s.title}>
            <h2 className="serif-display text-2xl md:text-3xl text-navy">{s.title}</h2>
            <p className="mt-3 text-navy/75 leading-relaxed">{s.body}</p>
          </section>
        ))}
      </div>
    </div>
  );
}
